import React, { Component } from 'react';
import some from 'lodash/some';
import isEmpty from 'lodash/isEmpty';
import { PagerButtons } from 'sure-components';
import PlanDisclaimer from 'shared/lib/components/PlanDisclaimer';
import AddressForm from 'shared/lib/components/AddressForm';
import PropTypes from 'prop-types';
import * as analytics from 'shared/lib/analytics';
import './BaggageAddressView.css';

const propTypes = {
  baggageLocation: PropTypes.object,
  disclaimer: PropTypes.string,
  saveBaggageLocation: PropTypes.func,
  getBaggagePlansView: PropTypes.func,
};

const defaultProps = {
  disclaimer: null,
};

class BaggageAddressView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isInProgress: false,
    };
  }

  componentDidMount() {
    analytics.page('BRB - Address');
  }

  handleNext = e => {
    if (e) {
      e.preventDefault();
    }

    this.setState({
      isInProgress: true,
    });
    this.residenceAddressInput
      .getGeocodedValue()
      .then(geocodedData => {
        // XXX: Fallback to NYC for South African places to prevent Chubb plans.
        if (this.props.baggageLocation.country === 'ZA') {
          geocodedData.lat = 40.7551055;
          geocodedData.lng = -73.988398;
        }
        this.props.saveBaggageLocation(geocodedData);
        return this.props.getBaggagePlansView();
      })
      .then(() => {
        this.props.navTo('/baggage-protection/flight');
      })
      .catch(error => {
        this.setState({
          isInProgress: false,
        });
        this.props.onError(error);
      });
  };

  get isNextDisabled() {
    return some(
      [
        this.props.baggageLocation.streetAddress,
        this.props.baggageLocation.city,
        this.props.baggageLocation.region,
        this.props.baggageLocation.postal,
      ],
      isEmpty
    );
  }

  render() {
    const { baggageLocation, disclaimer, saveBaggageLocation } = this.props;

    return (
      <div className="BaggageAddressView Container Container--small">
        <h1 className="BaggageAddressView-heading">What is your address?</h1>
        <form className="BaggageAddressView-form" onSubmit={this.handleNext}>
          <AddressForm
            streetAddress={baggageLocation.streetAddress}
            unit={baggageLocation.unit}
            city={baggageLocation.city}
            region={baggageLocation.region}
            postal={baggageLocation.postal}
            country={baggageLocation.country}
            onChange={saveBaggageLocation}
            ref={c => (this.residenceAddressInput = c)}
          />
          <input
            type="submit"
            style={{ display: 'none' }}
            ref={c => (this.inputSubmit = c)}
          />
          <PagerButtons
            onNext={this.handleNext}
            isInProgress={this.state.isInProgress}
            isBackDisabled={true}
            isNextDisabled={this.isNextDisabled}
          />
        </form>
        <PlanDisclaimer text={disclaimer} />
      </div>
    );
  }
}

BaggageAddressView.propTypes = propTypes;
BaggageAddressView.defaultProps = defaultProps;

export default BaggageAddressView;
